<i18n>
{
  "en": {
    "config": "Config",
    "launch": "Launch",
    "pause": "Pause",
    "start_live": "Live Streaming",
    "stop_live": "Stop Streaming",
    "expire_time": "Expire at",
    "free_trial": "TRIAL",
    "bonus": "FREE",
    "test": "TEST",
    "standard": "STANDARD",
    "premium": "PREMIUM",
    "general_game_status_launching": "The game is logging in automatically. Please wait a moment.",
    "mlb9i_game_status_launching": "Game is launching. Please do not leave.",
    "mlb9i_game_status_wait_for_input": "Please start the live streaming and input the login info.",
    "tsum_game_status_wait_for_input": "Please check the 4-pin codes of 2-factor authentication by live streaming, and input those codes in your LINE app to complete the game login process.",
    "game_status_playing": "Game is auto playing. It is OK to close the web browser, XRobotmon keeps playing on the cloud. When you want to play game on mobile phone, please [Pause] XRobotmon.",
    "general_login_failed_reasons": "OOPS!! Login failed, reasons might be: 1. please confirm account and password are correct, account should be an email address instead of ID. 2. The game official server seems to be temporary unavailable! But don’t worry, XRobotmon will try logging you in every 20 mins.",
    "line_login_failed_reasons": "OOPS!! Login failed, reasons might be: 1. please confirm account and password are correct, account should be an email address instead of ID. If you have changed your password, please also update the password in XRobotmon settings. 2. There might be a LINE verification during the login process, please check the 4-pin codes via live streaming and input them in your LINE app to complete the login. 3. The game official server seems to be temporarily unavailable.",
    "general_login_failed_tips": "Login account or password is incorrect, please check it, noting that account should be an email address instead of ID.",
    "line_login_failed_tips": "If you encounter problems logging in, please refer to the graphic instructions in {link} to help you confirm and troubleshoot login problems.",
    "line_login_failed_link": "this link",
    "game_status_new_account": "You are currently using a brand-new account. In order to experience the full range of services provided by the in-game assistant, please advance your game progress first.",
    "webrtc_not_compatible": "Your iOS version is outdated. Please upgrade to iOS 12.2 (or above) to ensure live streaming stability.",
    "long_streaming": "Please reattach if you wish to keep streaming.",
    "long_streaming2": "The XRobotmon will continuously help playing your game remotely. Feel free to live stream again later.",
    "long_streaming3": "If you see some lag in the screen, this is due to the live streaming network traffic, not that the machine operation is affected!",
    "referral_code_copied": "Referral code {referralCode} copied, ask your friends to enjoy XRobotmon together!",
    "bonus_referrer_msg": "Share your referral code with friends, and you will get 5 days bonus, and your friend will get 5 days bonus! (Click to copy the code)",
    "tsum": "Tsum Tsum",
    "cookieKingdom": "Cookie Kingdom",
    "mlb9i": "MLB 9 Innings",
    "record": "Record",
    "firebaseNotReturnDevices": "Service is under maintenance! Please try again later.",
    "ErrorDeviceNoAvailableResource": "Service is under maintenance! Please try again later.",
    "subscriptionStatus": "Subscription status",
    "alreadyUnsubscribe": "：Subscription canceled",
    "subscribing": "：Subscribing",
    "wantUnsubscribe": "Cancel subscription",
    "areYouSureUnsubscribe": "Are you sure you want to cancel the subscription?",
    "unsubscribeWarning": "Please note that once you cancel, the subscription cannot be restored. If needed, you will have to subscribe to a new license.",
    "makeSureUnsubscribe": "Confirm cancellation!!",
    "keepSubscribe": "Keep subscribing",
    "unknownSubscriptionStatusError": "Unknown error has occurred, please contact our support",
    "unsubscribeSuccessMessage": "If you like our service, please recommend us to your friends, we really appreciate it.\nThanks so much for having fun with us 😊",
    "pleaseTellUsYourReasonToUnsubscribe": "Before you unsubscribe, please tell us your reason, we will try our best to improve our service quality",
    "other": "Other",
    "highPrice": "High Price",
    "dontWantToPlayAnymore": "Don't Want To Play Anymore"
  },
  "zhHant": {
    "config": "設定",
    "launch": "啟動",
    "pause": "暫停",
    "start_live": "開始直播",
    "stop_live": "停止直播",
    "expire_time": "有效時間",
    "free_trial": "試用版",
    "bonus": "免費版",
    "test": "測試版",
    "standard": "標準版",
    "premium": "進階版",
    "general_game_status_launching": "正在自動進行遊戲登入程序，請稍後。",
    "mlb9i_game_status_launching": "遊戲正在啟動中，請先不要離開。",
    "mlb9i_game_status_wait_for_input": "請開始直播，輸入登入資訊。",
    "tsum_game_status_wait_for_input": "請開始直播，查看雙重驗證的4位數代碼，然後在您的LINE app上輸入以完成登入。",
    "game_status_playing": "遊戲已經自動進行中。XRobotmon會持續在雲端上掛機，可安心關閉網頁瀏覽器。當您要在手機上遊玩時，請務必 [暫停] XRobotmon。",
    "general_login_failed_reasons": "登入失敗，可能原因有：1. 檢查帳號密碼是否正確，請注意帳號為Email的形式，而不是ID。如果您曾經更換過密碼，也請同時更新XRobotmon設定中的密碼。 2. 有可能目前官方的登入系統發生短暫性故障，請不用擔心，XRobotmon會持續每20分鐘自動再嘗試登入，請稍後再回來查看即可。",
    "line_login_failed_reasons": "登入失敗，可能原因有：1. 檢查帳號密碼是否正確，請注意帳號為Email的形式，而不是ID。如果您曾經更換過密碼，也請同時更新XRobotmon設定中的密碼。 2. 有可能登入過程中出現Line驗證，請務必透過直播功能查看4pin代碼，然後在自己的手機上的Line app輸入以完成驗證登入。 3. 或是目前官方的登入系統發生短暫性故障。",
    "general_login_failed_tips": "登入帳號密碼不正確，請檢查一下。請注意帳號為Email的形式，而不是ID。若曾經更換過密碼，也請同時更新XRobotmon設定中的密碼。",
    "line_login_failed_tips": "登入遇到問題，請參考 {link} 內有圖文說明協助您確認並排除登入問題唷",
    "line_login_failed_link": "這個連結",
    "game_status_new_account": "您目前使用全新帳號，為了體驗遊戲小幫手完整服務功能，請先推進遊戲進度喔",
    "webrtc_not_compatible": "偵測到您的iOS系統過舊，直播功能可能無法連線，請升級到12.2以上版本。",
    "long_streaming": "直播太久了，休息一下吧。",
    "long_streaming2": "請不用擔心，您的機器仍在遠端努力運行中，您隨時都可以再次監視他。",
    "long_streaming3": "如果您看到畫面有些卡頓，這是直播網路流量的關係，並非機器運作有受到影響喔！",
    "referral_code_copied": "推薦代碼 {referralCode} 已幫您複製好了，可以用任何您喜愛的方式分享給朋友呦。",
    "bonus_referrer_msg": "現在推薦朋友使用您的序號訂閱，您的此授權將獲得5天、朋友5天的額外獎勵(點一下代碼複製)",
    "tsum": "Tsum Tsum",
    "cookieKingdom": "薑餅人王國",
    "mlb9i": "MLB 9局職棒",
    "record": "紀錄",
    "firebaseNotReturnDevices": "服務維護中，請稍後再試",
    "ErrorDeviceNoAvailableResource": "服務維護中，請稍後再試",
    "subscriptionStatus": "訂閱狀態",
    "alreadyUnsubscribe": "：已經取消訂閱",
    "subscribing": "：訂閱中",
    "wantUnsubscribe": "我想要取消訂閱",
    "areYouSureUnsubscribe": "您確定要取消訂閱？",
    "unsubscribeWarning": "請注意，按下取消後，無法恢復訂閱，若有需要請重新訂閱新授權。",
    "makeSureUnsubscribe": "確定取消!!",
    "keepSubscribe": "我要繼續使用",
    "unknownSubscriptionStatusError": "未知錯誤，若需要變更訂閱狀態請聯繫客服人員",
    "unsubscribeSuccessMessage": "如果喜歡我們的服務的話，再幫我們推薦給您的朋友呦\n感謝您的愛護，謝謝與我們一起玩得開心😊",
    "pleaseTellUsYourReasonToUnsubscribe": "在您取消訂閱之前，請告訴我們您的原因，我們會努力改進服務品質",
    "other": "其他",
    "highPrice": "價格太高",
    "dontWantToPlayAnymore": "不想玩了/退坑"
  },
  "ja": {
    "config": "設定",
    "launch": "開始",
    "pause": "一時停止",
    "start_live": "ライブ配信",
    "stop_live": "ライブ停止",
    "expire_time": "終了日時",
    "free_trial": "トライアル",
    "bonus": "無料版",
    "test": "テスト版",
    "standard": "有料版",
    "premium": "有料プラス",
    "general_game_status_launching": "ゲームが自動的にログイン中です。少々お待ちくださいね。",
    "mlb9i_game_status_launching": "ゲームが起動中なので、まだ立ち去らないでください。",
    "mlb9i_game_status_wait_for_input": "ライブ配信を開始して、ログイン情報を入力してください。",
    "tsum_game_status_wait_for_input": "ライブ配信を開始し、2段階認証用の4桁のコードを表示し、LINEアプリに入力してログインを完了してください。",
    "game_status_playing": "ゲームは自動的に進行中です。ウェブブラウザは閉じて大丈夫です。スマホでゲームを遊びたいときは、その前に必ずXRobotmon [一時停止] を押してください。",
    "general_login_failed_reasons": "ログイン出来ない他の原因:1.アカウントのパスワードが正しいかを確認します。アカウントはIDではなくメールです。2.ゲームの公式システムが一時的に障害を起こしている場合があります。後でもう一度試してみてください。",
    "line_login_failed_reasons": "ログインに失敗しました。考えられる原因は以下の通りです：1. アカウントとパスワードが正しいか確認してください。アカウントはIDではなくメールアドレスを使用してください。パスワードを変更した場合は、必ずXRobotmonの設定でも同じパスワードに更新してください。2. ログイン時にLINEの認証が発生することがあります。ライブ配信で4桁のコードを確認し、LINEアプリに入力してログインを完了してください。3. 現在、ゲーム公式サーバーが一時的に利用できない可能性があります。しばらく待ってから再試行してください。",
    "general_login_failed_tips": "アカウントのパスワードが正しいか確認します。アカウントはIDではなくメールです。",
    "line_login_failed_tips": "ログインで問題が発生した場合は、{link} にある図の手順を参照して、ログインの問題の確認とトラブルシューティングを行ってください。",
    "line_login_failed_link": "このリンク",
    "game_status_new_account": "現在、新しいアカウントをお使いです。ゲームアシスタントの完全なサービス機能を体験するために、まずゲームの進行を進めてくださいね。",
    "webrtc_not_compatible": "iOS12.1以前のシステムではライブブロードキャストが接続されない可能性があります。iOS 12.2以降にアップグレードしてください。",
    "long_streaming": "一回のライブ時間が過ぎました。少し休んでくださいね",
    "long_streaming2": "Xロボットモンは只今働いています。ご安心ください。ゲームの調子はライブ配信でご覧いただけますと幸いです。",
    "long_streaming3": "画面に多少の遅れが見られる場合、これはライブ ブロードキャスト ネットワーク トラフィックが原因であり、マシンの動作が影響を受けているわけではありません。",
    "referral_code_copied": "友達紹介コードをコピーしました。今すぐ友達にシェアしましょうー",
    "bonus_referrer_msg": "今お客様の紹介コードをお友達がご利用になると、お客様のライセンスに5日、お友達に5日の追加が付きます。 (クリックしてコピー)",
    "tsum": "ツムツム",
    "cookieKingdom": "クッキーキングダム",
    "mlb9i": "MLB 9イニングス",
    "record": "記録",
    "firebaseNotReturnDevices": "サーバーメンテナンス中、暫くお待ち下さい。",
    "ErrorDeviceNoAvailableResource": "サーバーメンテナンス中、暫くお待ち下さい。",
    "subscriptionStatus": "ライセンス状態の確認",
    "alreadyUnsubscribe": "：自動決済キャンセルした",
    "subscribing": "：ライセンス利用中",
    "wantUnsubscribe": "自動決済を解約したい",
    "areYouSureUnsubscribe": "解約を再確認?",
    "unsubscribeWarning": "解約したら、ライセンス料金の自動決済もキャンセルされる",
    "makeSureUnsubscribe": "キャンセルの確認",
    "keepSubscribe": "使い続けたい",
    "unknownSubscriptionStatusError": "不明なエラーが発生しました。カスタマーサポートをご連絡ください。",
    "unsubscribeSuccessMessage": "XRobotmon にご興味を持ってくださり、心から感謝いたします。ご利用頂いたいお友達をご紹介いただければ幸いです。\nもし何かご要望がありましたら、いつでもご連絡ください。今後ともツムツムお楽しみくださいますようお願い致します。😊",
    "pleaseTellUsYourReasonToUnsubscribe": "解約する前に、解約理由を教えてください。サービスの品質向上に努めます。",
    "other": "その他",
    "highPrice": "価格が高い",
    "dontWantToPlayAnymore": "もう遊びたくない"
  },
  "ko": {
    "config": "설정",
    "launch": "매크로 작동",
    "pause": "매크로 중지",
    "start_live": "실시간 모니터링",
    "stop_live": "모니터링 중지",
    "expire_time": "라이센스 기간: ",
    "free_trial": "체험버전",
    "bonus": "무료버전",
    "test": "테스트버전",
    "standard": "일반버전",
    "premium": "프리미엄",
    "general_game_status_launching": "게임이 자동으로 로그인 중입니다. 잠시만 기다려 주세요.",
    "mlb9i_game_status_launching": "게임이 시작 중이므로, 아직 떠나지 마세요.",
    "mlb9i_game_status_wait_for_input": "라이브 방송을 시작하고 로그인 정보를 입력해주세요.",
    "tsum_game_status_wait_for_input": "라이브 스트리밍을 통해 2단계 인증의 4자리 코드를 확인한 후, 해당 코드를 LINE 앱에 입력하여 게임 로그인 프로세스를 완료하세요.",
    "game_status_playing": "게임이 자동으로 진행 중입니다. 인터넷 브라우저를 닫아도 계속해서 작동됩니다. 스마트폰으로 게임을 접속하기 원하시는 경우 XRobotMon에서 매크로를 [일시정지] 해주세요.",
    "general_login_failed_reasons": "로그인에 실패하였습니다. 1. 계정 비밀번호가 올바른지 확인해주세요. 계정 ID는 이메일 형식이여야 합니다. 2. 현재 게임 서버가 일시적인 장애가 있을 수 있습니다. 잠시 후 다시 시도해주세요.",
    "line_login_failed_reasons": "로그인에 실패하였습니다. 1. 아이디 혹은 비밀번호가 올바른지 확인해주세요. 계정 ID는 이메일 형식이여야 합니다. LINE/게임 내에서 비밀번호를 변경한 경우, XRobotmon 설정에서도 비밀번호를 업데이트 해주세요. 2. 로그인 과정에서 LINE 인증이 발생할 수 있습니다. 라이브 스트리밍을 통해 4자리 코드를 확인하고, LINE 앱에 입력하여 로그인을 완료하세요. 3. 현재 게임 서버가 일시적인 장애가 있을 수 있습니다.",
    "general_login_failed_tips": "아이디 혹은 비밀번호가 올바르지 않습니다. 계정 ID는 이메일 형식이여야 합니다.",
    "line_login_failed_tips": "로그인하는 데 문제가 있는 경우 {link}의 그래픽 지침을 참조하여 로그인 문제를 확인하고 해결하는 데 도움을 받으십시오.",
    "line_login_failed_link": "이 링크",
    "game_status_new_account": "현재 새로운 계정을 사용 중이십니다. 게임 도우미의 완전한 서비스 기능을 경험하려면 먼저 게임 진행을 해 주세요.",
    "webrtc_not_compatible": "실시간 모니터링은 iOS버전 12.2 이상에서 지원합니다. iOS버전을 업데이트 해주세요.",
    "long_streaming": "실시간 모니터링을 오랫동안 키고 있어 연결이 해제되었습니다.",
    "long_streaming2": "걱정하지 마세요. 매크로는 계속해서 작동하고 있습니다. 언제든지 다시 실시간 모니터링을 확인할 수 있습니다.",
    "long_streaming3": "화면에 약간의 지연이 보이는 경우 이는 라이브 방송 네트워크 트래픽으로 인한 것이지 기기 작동에 영향을 미치는 것은 아닙니다!",
    "referral_code_copied": "추천코드 {referenceCode}가 복사되었습니다. 친구들에게 공유하세요!",
    "bonus_referrer_msg": "새로운 친구에게 추천코드를 공유하세요. 친구가 구독하면 5일 추가, 친구에게 5일 추가! (클릭하여 코드 복사)",
    "tsum": "라인 디즈니 썸썸",
    "cookieKingdom": "쿠키런: 킹덤",
    "mlb9i": "MLB 9이닝스",
    "record": "기록",
    "firebaseNotReturnDevices": "서비스 점검중입니다. 잠시후 다시 시도해주세요.",
    "ErrorDeviceNoAvailableResource": "서비스 점검중입니다. 잠시후 다시 시도해주세요.",
    "subscriptionStatus": "라이센스 상태",
    "alreadyUnsubscribe": "라이센스 구독이 취소되었습니다.",
    "subscribing": "라이센스 구독 중",
    "wantUnsubscribe": "라이센스 구독 취소",
    "areYouSureUnsubscribe": "라이센스 구독을 취소하시겠습니까?",
    "unsubscribeWarning": "취소된 라이센스 구독은 복구할 수 없으며, 만료 후 계속 사용할 수 없습니다!",
    "makeSureUnsubscribe": "구독을 취소합니다.",
    "keepSubscribe": "구독을 계속 사용합니다.",
    "unknownSubscriptionStatusError": "알 수 없는 오류입니다. 문의해주시면 처리해드리겠습니다.",
    "unsubscribeSuccessMessage": "마음에 드신다면 친구에게 추천해주시면 감사하겠습니다. 이용해주셔서 감사합니다.",
    "pleaseTellUsYourReasonToUnsubscribe": "구독을 취소하기 전에 이유를 알려주세요. 서비스 품질을 개선하겠습니다.",
    "other": "기타",
    "highPrice": "가격이 높음",
    "dontWantToPlayAnymore": "더 이상 게임을 하고 싶지 않음"
  }
}
</i18n>
<template>
  <div>
    <v-card class="mx-auto">
      <v-dialog v-model="referral_code_copying_dialog" persistent max-width="400">
        <template v-slot:activator="{ on }">
          <v-alert value="true" color="info">
            <span>{{ $t('bonus_referrer_msg') }}</span>
            <v-btn
              small
              outline
              flat
              dark
              v-on="on"
              @click="$copyText(license.licenseId)"
              block
              round
              :style="{ 'text-transform': 'none' }"
              >{{ license.licenseId }}</v-btn
            >
          </v-alert>
        </template>

        <v-card>
          <v-card-text>{{ $t('referral_code_copied', { referralCode: license.licenseId }) }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="referral_code_copying_dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <form
        :style="{
          width: '0px',
          height: '0px',
          padding: '0px',
          margin: '0px',
        }"
        v-on:submit="$event => submit($event)"
      >
        <input
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          :id="hiddenInputFieldId"
          v-on:beforeinput="beforeInputHiddenField($event)"
          v-on:input="inputHiddenField($event)"
          value="gg30cm"
          :style="{
            position: 'sticky',
            top: '0',
            width: '0px',
            height: '0px',
            padding: '0px',
            margin: '0px',
          }"
        />
      </form>
      <!-- streaming screenshot -->
      <div
        v-if="!license.device || (license.device && streamingState === ConnectingState.OFFLINE)"
        class="streaming-container"
      >
        <v-img contain :src="getScreenshot" aspect-ratio="1."></v-img>
        <div class="streaming-mask">
          <button
            v-show="deviceState !== ConnectingState.OFFLINE"
            @click="createConnection"
            :disabled="isLiveButtonDisabled"
          >
            {{ $t('start_live') }}
          </button>
        </div>
      </div>
      <!-- streaming video -->
      <div :style="{ position: 'relative', width: '100%', height: 'auto' }">
        <video
          playsinline
          autoplay
          muted
          v-show="license.device && streamingState == ConnectingState.ONLINE && videoStreamOpened()"
          :id="videoId"
          v-on:click="mouseClicked($event)"
          :style="{ width: '100%', height: 'auto' }"
        ></video>
        <span id="warningText" :style="{ position: 'absolute', top: '65%', left: '5%', color: 'red' }"></span>
      </div>

      <v-container
        v-show="license.device && streamingState == ConnectingState.CONNECTING"
        column
        justify-space-between
        fill-height
        bg
        text-xs-center
      >
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-progress-circular rotate="270" size="140" width="10" :value="connectionPercent" color="primary">
              {{ connectionMsg }}
            </v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>

      <v-alert
        :value="webrtcCompatible === false && license.device && streamingState == ConnectingState.CONNECTING"
        color="error"
        >{{ $t('webrtc_not_compatible') }}</v-alert
      >

      <!-- GAME STATUS FOR LOGIN_FAILED -->
      <v-alert
        :value="
          license &&
          license.taskStatus === TaskStatus.LOGIN_FAILED &&
          (license.loginFailedCount === undefined || license.loginFailedCount < 5)
        "
        color="warning"
        >{{
          license.supportGame === 'tsum' ? $t('line_login_failed_reasons') : $t('general_login_failed_reasons')
        }}</v-alert
      >
      <v-alert
        :value="license && license.taskStatus === TaskStatus.LOGIN_FAILED && license.loginFailedCount >= 5"
        color="error"
      >
        <div v-if="license.supportGame === 'tsum'">
          <i18n path="line_login_failed_tips" tag="div">
            <template v-slot:link>
              <a :href="lineLoginFailedLink" target="_blank">
                {{ $t('line_login_failed_link') }}
              </a>
            </template>
          </i18n>
        </div>
        <div v-else>{{ $t('general_login_failed_tips') }}</div>
      </v-alert>

      <!-- GAME STATUS FOR LAUNCHING -->
      <v-alert :value="license.taskStatus === TaskStatus.LAUNCHING" color="info">
        {{ license.supportGame === 'mlb9i' ? $t('mlb9i_game_status_launching') : $t('general_game_status_launching') }}
      </v-alert>

      <!-- GAME STATUS FOR WAIT_FOR_INPUT -->
      <v-alert :value="license.taskStatus === TaskStatus.WAIT_FOR_INPUT" color="warning">
        {{
          license.supportGame === 'tsum'
            ? $t('tsum_game_status_wait_for_input')
            : license.supportGame === 'mlb9i'
            ? $t('mlb9i_game_status_wait_for_input')
            : ''
        }}
      </v-alert>

      <!-- GAME STATUS FOR PLAYING -->
      <v-alert :value="license.taskStatus === TaskStatus.PLAYING" color="success">
        {{ $t('game_status_playing') }}</v-alert
      >

      <!-- GAME STATUS FOR NEW_ACCOUNT -->
      <v-alert :value="license && license.taskStatus === TaskStatus.game_status_new_account" color="error">
        {{ $t('game_status_new_account') }}
      </v-alert>

      <v-card-text>
        <v-layout row align-center>
          <v-flex grow>
            <v-chip v-if="license.type === 'trial'" outline small>
              {{ $t('free_trial') }}
            </v-chip>
            <v-chip v-else-if="license.type === 'bonus'" color="blue" outline small>
              {{ $t('bonus') }}
            </v-chip>
            <v-chip v-else-if="license.type === 'test'" color="green" outline small>
              {{ $t('test') }}
            </v-chip>
            <v-chip v-else color="orange" text-color="white" small @click="showSubscriptionStatus(license.licenseId)">
              {{ $t('standard') }}
            </v-chip>
            <v-chip v-if="license.supportGame === 'tsum'" color="#16B9D9" text-color="white" small>
              {{ $t(license.supportGame) }}
            </v-chip>
            <v-chip v-if="license.supportGame === 'cookieKingdom'" color="#E2A968" text-color="white" small>
              {{ $t(license.supportGame) }}
            </v-chip>
            <v-chip v-if="license.supportGame === 'mlb9i'" color="#202D46" text-color="white" small>
              {{ $t(license.supportGame) }}
            </v-chip>
          </v-flex>
          <v-flex shrink>
            <v-chip
              v-if="
                (license.supportGame === 'tsum' || lodash.isEmpty(license.supportGame)) &&
                license.taskConfig !== null &&
                license.taskConfig.recordFolderId !== ''
              "
              color="#16B9D9"
              text-color="white"
              small
              @click="goRecordPage(license.taskConfig.recordFolderId)"
            >
              <v-icon>mdi-gesture-tap</v-icon>
              {{ $t('record') }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-text>
        <v-layout row align-center>
          <v-flex grow>
            <div>{{ $t('expire_time') }}: {{ validUntil }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="deviceState === ConnectingState.OFFLINE"
          :disabled="isStartButtonDisabled"
          :loading="deviceState === ConnectingState.CONNECTING"
          color="green"
          @click="start_or_stop"
          >{{ $t('launch') }}</v-btn
        >
        <v-btn
          v-else
          :disabled="isStartButtonDisabled"
          :loading="deviceState === ConnectingState.CONNECTING"
          color="red"
          @click="start_or_stop"
          >{{ $t('pause') }}</v-btn
        >
        <v-btn
          v-if="streamingState === ConnectingState.ONLINE"
          color="red"
          :disabled="isLiveButtonDisabled"
          @click="stopConnection"
          >{{ $t('stop_live') }}</v-btn
        >

        <v-spacer></v-spacer>

        <v-btn color="grey" @click="config" :disabled="deviceState != ConnectingState.OFFLINE">
          {{ $t('config') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="subscriptionStatusDialog" persistent max-width="400">
      <v-card>
        <v-card-title>
          {{ $t('subscriptionStatus') }}
          <div v-if="subscriptionStatusLicense !== null">
            <div v-if="subscriptionStatusLicense.isCanceled">
              {{ $t('alreadyUnsubscribe') }}
            </div>
            <div v-if="!subscriptionStatusLicense.isCanceled">
              <span>{{ $t('subscribing') }}</span>
            </div>
          </div>
        </v-card-title>
        <v-card-text v-if="subscriptionStatusLoading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-if="subscriptionStatusLicense !== null">
          <div>{{ $t('expire_time') }}: {{ validUntil }}</div>
        </v-card-text>
        <v-card-text v-if="subscriptionStatusLicense !== null">
          <div>{{ $t('unsubscribeSuccessMessage') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="subscriptionStatusLicense !== null && !subscriptionStatusLicense.isCanceled"
            color="grey"
            outline
            small
            @click="unsubscribeDialog = true"
            :loading="unsubscribeLoading"
          >
            {{ $t('wantUnsubscribe') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="hideSubscriptionStatus()">OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="unsubscribeDialog" persistent max-width="400">
      <v-card>
        <v-card-text>{{ $t('areYouSureUnsubscribe') }}</v-card-text>
        <v-card-text>
          {{ $t('unsubscribeWarning') }}
        </v-card-text>
        <v-card-text>
          <p>{{ $t('pleaseTellUsYourReasonToUnsubscribe') }}</p>
          <v-form ref="form" v-model="isUnsubscribeReasonValid" lazy-validation>
            <v-radio-group v-model="unsubscribeReason" validate-on-blur :rules="unsubscribeFormRules">
              <v-radio :label="$t(reasons.highPrice)" :value="reasons.highPrice" />
              <v-radio :label="$t(reasons.dontWantToPlayAnymore)" :value="reasons.dontWantToPlayAnymore" />
              <v-radio :label="$t(reasons.other)" :value="reasons.other" />
              <v-textarea
                v-if="unsubscribeReason === reasons.other"
                outline
                v-model="otherReason"
                :rules="otherReasonRules"
              />
            </v-radio-group>
          </v-form>
          <HighPriceHint :isShow="unsubscribeReason === reasons.highPrice" :supportGame="license.supportGame" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small :color="isUnsubscribeReasonValid ? 'red' : 'blue-grey lighten-4'" outline @click="unsubscribe">
            {{ $t('makeSureUnsubscribe') }}
          </v-btn>
          <v-btn small color="primary" @click="unsubscribeDialog = false">
            {{ $t('keepSubscribe') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="subscriptionStatusErrorDialog" persistent max-width="400">
      <v-card>
        <v-card-title>{{ $t('subscriptionStatus') }}</v-card-title>
        <v-card-text>{{ $t('unknownSubscriptionStatusError') }} {{ errorMessage }}</v-card-text>
        <ContactInfo />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" outline @click="subscriptionStatusErrorDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="streaming_too_long_dialog" persistent max-width="400">
      <v-card>
        <v-card-text>{{ $t('long_streaming') }}</v-card-text>
        <v-card-text>{{ $t('long_streaming2') }}</v-card-text>
        <v-card-text>{{ $t('long_streaming3') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" outline @click="streaming_too_long_dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="errorCode !== ''" persistent max-width="400">
      <v-card>
        <v-card-text>{{ $t(errorCode) !== errorCode ? $t(errorCode) : errorCode }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" outline @click="errorCode = ''">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import assetMisc from '../assets/misc';
import _ from 'lodash';
import { ConnectingState, TaskStatus } from '../store/enum';
import moment from 'moment';
// import "moment/locale/en"; // en is a built-in locale, no need to import it explicitly
import 'moment/locale/zh-tw';
import 'moment/locale/ja';
import { setInterval, clearInterval } from 'timers';
import WebRTC from '../plugins/webrtc';
import { delay } from '../misc/util';
import ContactInfo from '../components/ContactInfo';
import HighPriceHint from '../components/HighPriceHint';

export default {
  name: 'DeviceCard',
  props: {
    license: {
      type: Object,
      required: true,
    },
  },
  components: { ContactInfo, HighPriceHint },
  data() {
    return {
      needFullScreen: false,
      lodash: _,
      isShowTip: false,
      errorCode: '',
      ConnectingState,
      TaskStatus,
      deviceState: this.license.device === null ? ConnectingState.OFFLINE : ConnectingState.ONLINE,
      streamingState: ConnectingState.OFFLINE,
      countDown: 100,
      videoId: '',
      hiddenInputFieldId: '',
      hiddenInputField: null,
      lastEventData: '',
      connectionMsg: '',
      connectionTimer: 0,
      connectionPercent: 0,
      referral_code_copying_dialog: false,
      streaming_too_long_dialog: false,
      subscriptionStatusDialog: false,
      subscriptionStatusLoading: false,
      subscriptionStatusLicense: null,
      unsubscribeDialog: false,
      unsubscribeLoading: false,
      subscriptionStatusErrorDialog: false,
      errorMessage: '',
      isUnsubscribeReasonValid: true,
      unsubscribeReason: undefined,
      otherReason: '',
      reasons: {
        highPrice: 'highPrice',
        dontWantToPlayAnymore: 'dontWantToPlayAnymore',
        other: 'other',
      },
      unsubscribeFormRules: [v => v === this.reasons.other && !this.otherReason.trim() && '', v => !v && ''],
      otherReasonRules: [v => this.unsubscribeReason === this.reasons.other && !v && ''],
    };
  },
  created() {
    if (
      (navigator.platform.indexOf('Mac') || navigator.platform.indexOf('Win')) &&
      this.license.supportGame === 'cookieKingdom'
    ) {
      this.needFullScreen = true;
    }

    this.videoId = 'remoteVideo-' + this.license.licenseId;
    this.hiddenInputFieldId = 'input-' + this.license.licenseId;
    this.hiddenInputField = document.getElementById(this.hiddenInputFieldId);

    this.listenLicenseUpdate = firebase
      .firestore()
      .collection('x_licenses')
      .doc(this.license.licenseId)
      .onSnapshot(doc => {
        const xLicense = doc.data();
        if (xLicense === undefined) {
          return;
        }
        console.log('onSnapshot, emit: ', this.license, xLicense);
        xLicense.device = this.license.device;
        this.$emit('updateLicenseById', xLicense);
      });
  },
  onBeforeUnmount() {
    this.listenLicenseUpdate = undefined;
  },
  computed: {
    validUntil() {
      let locale = this.$i18n.locale;
      if (locale === 'zhHant') {
        locale = 'zh-TW';
      }
      moment.locale(locale);
      return moment.unix(this.license.expireTime).format('lll');
    },
    getScreenshot() {
      if (this.deviceState === ConnectingState.ONLINE && this.license.device && this.license.device.screenshotBase64) {
        return 'data:image/jpeg;base64,' + this.license.device.screenshotBase64;
      } else {
        return assetMisc.robotmonLogoUrl;
      }
    },
    webrtcCompatible() {
      return WebRTC.isCompatible;
    },
    isStartButtonDisabled() {
      if (_.isEmpty(this.license.task) || this.deviceState === ConnectingState.CONNECTING) {
        return true;
      } else {
        return false;
      }
    },
    isLiveButtonDisabled() {
      if (!this.license.device || this.deviceState !== ConnectingState.ONLINE) {
        return true;
      } else if (this.streamingState == ConnectingState.CONNECTING) {
        return true;
      }
      return false;
    },
    enableUnsubscribe() {
      return this.unsubscribeReason;
    },
    lineLoginFailedLink() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'https://www.tsumtsum.app/en/xrobotmon-tutorial#h.cfg78uymwwfd';
        case 'zhHant':
          return 'https://www.tsumtsum.app/zh/xrobotmon-tutorial#h.q3v6lh569ycs';
        case 'ja':
          return 'https://www.tsumtsum.app/ja/xrobotmon-tutorial#h.t5ngav2nr9gn';
        case 'ko':
          return 'https://www.tsumtsum.app/ko/xrobotmon-tutorial#h.yie74pb623g4';
        default:
          return 'https://www.tsumtsum.app/en/xrobotmon-tutorial#h.cfg78uymwwfd';
      }
    },
  },
  watch: {
    streamingState: function (state) {
      if (state === ConnectingState.ONLINE) {
        this.countDown =
          this.license.taskStatus === TaskStatus.WAIT_FOR_INPUT || this.license.taskStatus === TaskStatus.LAUNCHING
            ? 300
            : 100;
        this.countHandler = setInterval(() => {
          this.countDown -= 1;
        }, 1000);
      } else {
        clearInterval(this.countHandler);
      }
      console.log('streamingState: ', this.streamingState);
    },
    deviceState: function (state) {
      if (state === ConnectingState.ONLINE) {
        // show tips
        this.isShowTip = true;
      } else {
        this.isShowTip = false;
      }
    },
    countDown: function (count) {
      // Auto recoonect if connection dropped during WAIT_FOR_INPUT
      if (
        count > 0 &&
        this.streamingState === ConnectingState.OFFLINE &&
        this.license.taskStatus === TaskStatus.WAIT_FOR_INPUT
      ) {
        console.log(`attemting to reconnect at count: ${count}`);
        this.createConnection();
        return;
      }

      if (count <= 0 && this.streamingState == ConnectingState.ONLINE) {
        let el = document.getElementById(this.videoId);
        if (el.srcObject) {
          el.srcObject = null;
        }

        const device = this.license.device;
        device.webRTC.disconnect();

        this.streaming_too_long_dialog = true;
      }
    },
  },
  methods: {
    async unsubscribe() {
      // check if unsubscribe reason is valid
      if (!this.validate()) {
        return;
      }

      this.unsubscribeDialog = false;
      this.unsubscribeLoading = true;
      // send unsubscribe reason to google sheet
      try {
        const userInputReason =
          this.unsubscribeReason === this.reasons.other ? this.otherReason : this.$t(this.unsubscribeReason);
        const formContent = new FormData();
        formContent.append('UserID', firebase.auth().currentUser.uid);
        formContent.append('Name', firebase.auth().currentUser.displayName);
        formContent.append('Email', firebase.auth().currentUser.email);
        formContent.append('Message', userInputReason);
        formContent.append('Time', new Date().toISOString());

        // this script was deployed on Google account, robotmon902@gmail.com
        // need to change api endpoint if the script is updated
        fetch(
          'https://script.google.com/macros/s/AKfycbzZSeUbwN75b8GVm_SWTCleDi-LaOY2AyPWwXGiT6FcFlh788_HEE_wpBtxI5TOBMzxfg/exec',
          {
            method: 'POST',
            body: formContent,
          }
        );
      } catch (e) {
        console.error('send reason to google sheet failed: ', e);
      }
      // handle unsubscribe
      try {
        const result = await firebase.functions().httpsCallable('xSubscriptionAPI-cancelSubscription')({
          licenseId: this.license.licenseId,
        });
        this.$gtag.event('subscription', 'cancel', this.license.userId, 1);
        this.$set(this, 'subscriptionStatusLicense', result.data);
      } catch (e) {
        this.subscriptionStatusErrorDialog = true;
        this.errorMessage = e.message;
      }
      this.unsubscribeReason = '';
      this.unsubscribeLoading = false;
    },
    async showSubscriptionStatus(licenseId) {
      console.log('showSubscriptionStatus', licenseId);
      this.subscriptionStatusDialog = true;
      this.subscriptionStatusLoading = true;
      try {
        const result = await firebase.functions().httpsCallable('xPaymentAPI-getLicenseSubscriptionStatus')({
          licenseId: this.license.licenseId,
        });
        this.$set(this, 'subscriptionStatusLicense', result.data);
      } catch (e) {
        this.subscriptionStatusDialog = false;
        this.subscriptionStatusErrorDialog = true;
        this.errorMessage = e.message;
      }
      this.subscriptionStatusLoading = false;
    },
    hideSubscriptionStatus() {
      this.subscriptionStatusDialog = false;
      this.subscriptionStatusLoading = false;
      this.subscriptionStatusLicense = null;
    },
    goRecordPage(recordId) {
      this.$gtag.event('tsumRecordPage', 'click', recordId, 1);
      this.$router.push(`/tsum-record/${recordId}`);
    },
    videoStreamOpened() {
      let el = document.getElementById(this.videoId);
      console.log('videoStreamOpened triggered: ', this.videoId, el);

      el.srcObject = this.license.device.videoStream;
      console.log('video stream opened: ', el, this.license.device.videoStream);

      if (this.license.taskStatus === TaskStatus.WAIT_FOR_INPUT) {
        const hiddenInputField = document.getElementById(this.hiddenInputFieldId);
        hiddenInputField.focus({
          preventScroll: true,
        });
      }
      return true;
    },
    createConnection() {
      const device = this.license.device;
      const deviceId = device.deviceId;

      this.streamingState = ConnectingState.CONNECTING;

      device.webRTC = new WebRTC(this.license.licenseId, deviceId, device.supportGame);

      device.webRTC.onConnected(event => {
        console.log('> webrtc connected!');
        this.streamingState = ConnectingState.ONLINE;
        device.videoStream = event.streams[0];
      });

      device.webRTC.onDisconnected(() => {
        console.log('> webrtc disconnected!');

        if (this.streamingState !== ConnectingState.OFFLINE) {
          this.streamingState = ConnectingState.OFFLINE;
          device.videoStream = undefined;
        }

        if (this.needFullScreen && document.fullscreenElement) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }

          screen.orientation.unlock();
        }
      });

      device.webRTC.connect();

      this.displayConnectMessage();
    },
    stopConnection() {
      if (this.streamingState == ConnectingState.ONLINE) {
        let el = document.getElementById(this.videoId);
        if (el.srcObject) {
          el.srcObject = null;
        }

        const device = this.license.device;
        device.webRTC.disconnect();
      }
    },
    start_or_stop() {
      if (this.deviceState === ConnectingState.OFFLINE) {
        this.start();
      } else if (this.deviceState === ConnectingState.ONLINE) {
        this.stop();
      }
    },
    start() {
      this.deviceState = ConnectingState.CONNECTING;

      firebase
        .functions()
        .httpsCallable('xPostStart')({
          licenseId: this.license.licenseId,
        })
        .then(response => {
          console.log('xPostStart complete, response: ', response);

          if (response.data.error === 'firebase failed to return updatedDevice') {
            // TODO: deprecate it
            this.errorCode = 'firebaseNotReturnDevices';
            this.deviceState = ConnectingState.OFFLINE;
            return;
          } else if (response.data.error === 'Start failed. No available resource') {
            this.errorCode = 'ErrorDeviceNoAvailableResource';
            this.deviceState = ConnectingState.OFFLINE;
            return;
          } else if (response.data.error) {
            this.errorCode = response.data.error;
            this.deviceState = ConnectingState.OFFLINE;
            return;
          }

          this.deviceState = ConnectingState.ONLINE;
          this.streamingState = ConnectingState.OFFLINE;

          console.log('started, emit: ', response.data.license);
          this.$emit('updateLicenseById', response.data.license);
        });
    },
    stop() {
      if (this.streamingState !== ConnectingState.OFFLINE) {
        this.stopConnection();
      }

      this.deviceState = ConnectingState.CONNECTING;

      firebase
        .functions()
        .httpsCallable('xPostStop')({
          licenseId: this.license.licenseId,
        })
        .then(response => {
          console.log('xPostStop complete, response: ', response);
          this.deviceState = ConnectingState.OFFLINE;

          console.log('stopped, emit: ', this.license);
          this.$emit('updateLicenseById', this.license);
        });
    },
    config() {
      if (this.license.supportGame == 'tsum') {
        this.$router.push({
          name: 'tsumConfig',
          // must use name, path not work. ref: https://stackoverflow.com/questions/45151810/passing-props-with-programmatic-navigation-vue-js
          params: { license: this.license },
        });
      } else if (this.license.supportGame == 'cookieKingdom') {
        this.$router.push({
          name: 'cookieConfig',
          // must use name, path not work. ref: https://stackoverflow.com/questions/45151810/passing-props-with-programmatic-navigation-vue-js
          params: { license: this.license },
        });
      } else if (this.license.supportGame == 'mlb9i') {
        this.$router.push({
          name: 'mlb9iConfig',
          // must use name, path not work. ref: https://stackoverflow.com/questions/45151810/passing-props-with-programmatic-navigation-vue-js
          params: { license: this.license },
        });
      }
    },
    async displayConnectMessage() {
      let idleMessageIdx = 0;
      let idleMessages = [
        'Switching to secure streaming connection',
        'Connecting to Emulator...',
        'Emulator is building connection...',
        'Emulator status check in progress...',
        'Emulator is about to ready for streaming',
      ];

      this.connectionPercent = 0;

      while (idleMessageIdx < idleMessages.length && this.streamingState !== ConnectingState.ONLINE) {
        this.connectionMsg = idleMessages[idleMessageIdx];
        this.connectionPercent = Math.min(90, this.connectionPercent + 5 + Math.random() * 10);
        await delay((0.5 + Math.random()) * 1000);
        this.connectionPercent = Math.min(90, this.connectionPercent + 5 + Math.random() * 10);
        await delay((0.5 + Math.random()) * 1000);
        idleMessageIdx++;
      }
    },
    submit(event) {
      event.preventDefault();

      if (this.license.taskStatus !== TaskStatus.WAIT_FOR_INPUT) {
        return;
      }

      // The <input> cannot handle 'enter' key event from the mobile keyboard
      this.license.device.webRTC.sendMessage(`runScript,keycode('ENTER', 100);console.log("keycode('ENTER', 100)")`);
    },
    beforeInputHiddenField(event) {
      document.getElementById(this.hiddenInputFieldId).value = 'gg30cm'; // init the hiddenInputFieldId with a value so that we can hit back

      if (this.license.taskStatus !== TaskStatus.WAIT_FOR_INPUT) {
        return;
      }

      // To handle special chars
      if (event.inputType === 'deleteContentBackward') {
        this.license.device.webRTC.sendMessage(`runScript,keycode('DEL', 50);console.log("keycode('DEL', 50)")`);
        return;
      } else if (event.inputType === 'insertLineBreak') {
        // Enter key from physical keyboard (not keyboard from phones)
        this.license.device.webRTC.sendMessage(`runScript,keycode('ENTER', 50);console.log("keycode('ENTER', 50)")`);
        return;
      }

      this.lastEventData = event.data;
    },
    inputHiddenField(event) {
      document.getElementById(this.hiddenInputFieldId).value = 'gg30cm'; // init the hiddenInputFieldId with a value so that we can hit back

      if (this.license.taskStatus !== TaskStatus.WAIT_FOR_INPUT) {
        return;
      }

      if (event.inputType === 'deleteContentBackward' || event.inputType === 'insertLineBreak') {
        return;
      }

      var keyboardInput = event.data;
      if (keyboardInput.length > 1) {
        keyboardInput = keyboardInput.slice(-1);
      }

      // check if the input character is within the range of ASCII
      const warningText = document.getElementById('warningText');
      if (event.data.charCodeAt(0) > 128) {
        warningText.innerText = 'Not allowed character';
        return;
      } else {
        warningText.innerText = '';
      }

      this.license.device.webRTC.sendMessage(
        `runScript,typing('${keyboardInput}', 50);console.log("typing('${keyboardInput}', 50)")`
      );

      this.lastEventData = event.data;
    },
    mouseClicked(event) {
      if (this.license.taskStatus !== TaskStatus.WAIT_FOR_INPUT) {
        return;
      }

      const hiddenInputField = document.getElementById(this.hiddenInputFieldId);
      hiddenInputField.focus({
        preventScroll: true,
      });

      // If mobile + crk/mlb: set to full screen
      if (this.needFullScreen && !document.fullscreenElement) {
        document.documentElement.requestFullscreen();

        if (screen.orientation.type === 'portrait-primary') {
          console.log('set to landscape, screen: ', screen);
          screen.orientation
            .lock('landscape')
            .then(() => {
              console.log('Orientation locked successfully.');
            })
            .catch(error => {
              console.error('Failed to lock orientation:', error);
            });
        }
      }

      var pnt = this.coordinateConversion(event.offsetX, event.offsetY);
      this.license.device.webRTC.sendMessage(
        `runScript,tap(${pnt.x},${pnt.y}, 50);console.log("tap(${pnt.x},${pnt.y}, 50)");`
      );
    },
    coordinateConversion(x, y) {
      const video = document.getElementById(this.videoId);
      var cs = getComputedStyle(video);
      var paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      var paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      var borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
      var borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

      // Element width and height minus padding and border
      var elementWidth = video.offsetWidth - paddingX - borderX;
      var elementHeight = video.offsetHeight - paddingY - borderY;

      if (this.license.supportGame === 'tsum') {
        return {
          x: Math.round((x / elementWidth) * 360),
          y: Math.round((y / elementHeight) * 640),
        };
      } else if (this.license.supportGame === 'cookieKingdom') {
        return {
          x: Math.round((x / elementWidth) * 640),
          y: Math.round((y / elementHeight) * 360),
        };
      } else if (this.license.supportGame === 'mlb9i') {
        return {
          x: Math.round((x / elementWidth) * 640),
          y: Math.round((y / elementHeight) * 360),
        };
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.streaming-container {
  position: relative;
  width: 100%;
}

.streaming-mask {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.streaming-mask > button {
  padding: 8px 8px;
  border-radius: 8px;
  border: 2px solid white;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
}

.streaming-mask > button:disabled {
  background-color: rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.streaming-mask > button[disabled]:hover {
  cursor: not-allowed;
}

.streaming-video {
  position: relative;
  width: 100%;
  height: 100%;
}

.streaming-video > button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  border-radius: 8px;
  color: white;
  padding: 8px;
}
</style>
